module.exports = __webpack_public_path__ + "img/delete.74de5e29.svg";